<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="客户列表" name="customers">
        <el-row>
          <el-input v-model="keywords" placeholder="请输入姓名或联系方式" clearable style="width: 300px; margin-right: 10px;"
            @clear="current_page = 1; queryCustomersList()"></el-input>

          <el-select v-model="queryPlatform" filterable clearable placeholder="全部平台"
            @change="current_page = 1; queryCustomersList()">
            <el-option v-for="item in platformOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button @click="current_page = 1; queryCustomersList()" icon="el-icon-search" circle
            title="查询"></el-button>
          <el-button @click="addCustomer()" icon="el-icon-plus" circle title="新增"></el-button>
        </el-row>
        <br>
        <el-table :data="customersList" border style="width: 100%" height="650" v-loading="vLoading">
          <el-table-column prop="company" label="公司"></el-table-column>
          <el-table-column prop="level" label="等级" width="80"></el-table-column>
          <el-table-column prop="contactor" label="联系人" width="100"></el-table-column>
          <el-table-column prop="nation" label="国家" width="80"></el-table-column>
          <el-table-column prop="company_site" label="公司网址"></el-table-column>
          <el-table-column prop="email" label="电子邮箱" width="220"></el-table-column>
          <el-table-column prop="telephone" label="电话"></el-table-column>
          <el-table-column prop="supplier" label="供应商及价格水平" width="180"></el-table-column>
          <el-table-column prop="status" label="状态" width="80"></el-table-column>
          <el-table-column prop="last_contact_at" label="最后联系时间"></el-table-column>
          <el-table-column label="操作" width="220">
            <template v-slot="scope">
              <el-button type="primary" icon="el-icon-view" @click="editCustomers(scope.row)" circle
                title="编辑"></el-button>
              <el-button :type="scope.row.in_auto_followed ? 'success' : 'info'"
                :icon="scope.row.in_auto_followed ? 'el-icon-check' : 'el-icon-close'"
                @click="followCustomers(scope.row)" circle title="跟踪"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="customersTotal"
            @size-change="changeCustomersSize" @current-change="currentCustomersChange" :page-sizes="[10, 20, 50, 100]"
            :page-size="size">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="跟踪信" name="follow_letter">
        <el-row>
          <el-input v-model="followLettersKeywords" placeholder="请输入标题或者关键字" clearable
            style="width: 300px; margin-right: 10px;" @clear="queryFollowLettersList()"></el-input>
          <el-button @click="queryFollowLettersList()" icon="el-icon-search" circle title="搜索"></el-button>
          <el-button @click="addFollowLetter()" icon="el-icon-plus" circle title="新增"></el-button>
        </el-row>
        <br>
        <el-table :data="followLettersList" border style="width: 100%" height="650">
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column prop="content" label="预览">
            <template v-slot="scope">
              <el-popover placement="top" width="200" trigger="hover" v-model="scope.row.popoverVisible">
                <div v-html="scope.row.content"></div>
                <div slot="reference" class="reference">
                  <i class="el-icon-view"></i>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="product" label="适用产品"></el-table-column>
          <el-table-column prop="name_cn" label="创建者"></el-table-column>
          <el-table-column prop="status" label="状态"></el-table-column>
          <el-table-column label="操作" width="220">
            <template v-slot="scope">
              <el-button icon="el-icon-view" @click="editFollowLetter(scope.row)" circle title="编辑"></el-button>
              <el-button type="danger" icon="el-icon-delete" @click="deleteFollowLetter(scope.row)" circle
                title="删除"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="followLettersTotal"
            @size-change="changeFollowLettersSize" @current-change="currentFollowLettersChange"
            :page-sizes="[10, 20, 50, 100]" :page-size="followLettersSize">
          </el-pagination>
        </div>
        <el-dialog title="新建跟踪信" :visible.sync="addAutoFollowLettersVisible" :close-on-click-modal="false"
          style="margin-top: -100px;">
          <el-form :model="addAutoFollowLettersForm" label-width="80px" :rules="addAutoFollowLettersRules"
            ref="addAutoFollowLettersForm" v-loading="addAutoFollowLettersLoading">
            <el-row>
              <el-col :span="24">
                <el-form-item label="标题" prop="title">
                  <el-input v-model="addAutoFollowLettersForm.title"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="正文" prop="content">
                  <quill-editor v-model="addAutoFollowLettersForm.content" ref="myQuillEditor" :options="editorOption">
                  </quill-editor>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelAddAutoFollowLetters">取 消</el-button>
            <el-button type="primary" @click="comfirmAddAutoFollowLetters">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="编辑跟踪信" :visible.sync="editAutoFollowLettersVisible" :close-on-click-modal="false"
          style="margin-top: -100px;">
          <el-form :model="editAutoFollowLettersForm" label-width="80px" :rules="editAutoFollowLettersRules"
            ref="editAutoFollowLettersForm" v-loading="editAutoFollowLettersLoading">
            <el-row>
              <el-col :span="24">
                <el-form-item label="标题" prop="title">
                  <el-input v-model="editAutoFollowLettersForm.title"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="正文" prop="content">
                  <quill-editor v-model="editAutoFollowLettersForm.content" ref="myQuillEditor" :options="editorOption">
                  </quill-editor>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelEditAutoFollowLetters">取 消</el-button>
            <el-button type="primary" @click="comfirmEditAutoFollowLetters">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="客户回收站" name="recycle_bin">
        <el-table :data="recycleBinList" border style="width: 100%" height="650">
          <el-table-column prop="company" label="公司"></el-table-column>
          <el-table-column prop="contactor" label="联系人" width="100"></el-table-column>
          <el-table-column prop="nation" label="国家" width="80"></el-table-column>
          <el-table-column prop="company_site" label="公司网址"></el-table-column>
          <el-table-column prop="email" label="电子邮箱" width="220"></el-table-column>
          <el-table-column prop="telephone" label="电话"></el-table-column>
          <el-table-column prop="last_contact_at" label="标记时间"></el-table-column>
          <el-table-column label="操作" width="220">
            <template v-slot="scope">
              <el-button icon="el-icon-view" @click="viewRecycleBinCustomers(scope.row)" circle title="查看"></el-button>
              <el-button type="success" icon="el-icon-refresh-left" @click="restoreRecycleBinCustomers(scope.row)"
                circle title="还原"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="recycleBinTotal"
            @size-change="changeRecycleBinSize" @current-change="currentRecycleBinChange"
            :page-sizes="[10, 20, 50, 100]" :page-size="recycleBinSize">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="地区分布" name="worldmap">
        <div id="main" class="main"></div>
      </el-tab-pane>
      <el-dialog title="新建联系人" :visible.sync="addCustomerVisible" :close-on-click-modal="false"
        style="margin-top: -100px;">
        <el-form :model="addCustomerForm" label-width="160px" :rules="addCustomerRules" ref="addCustomerForm"
          v-loading="addCustomerLoading">
          <el-row>
            <el-col :span="12">
              <el-form-item label="公司名称" prop="company">
                <el-input v-model="addCustomerForm.company"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公司网址" prop="company_site">
                <el-input v-model="addCustomerForm.company_site"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人" prop="contactor">
                <el-input v-model="addCustomerForm.contactor"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="等级" prop="level">
                <el-select v-model="addCustomerForm.level" style="width: 100%">
                  <el-option v-for="item in levelsOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="国家">
                <el-select v-model="addCustomerForm.nation_id" filterable clearable placeholder="请选择"
                  @change="getCities($event, 'add')" style="width: 100%">
                  <el-option v-for="item in countriesOption" :key="item.area_id" :label="item.name"
                    :value="item.area_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地区">
                <el-select v-model="addCustomerForm.area_id" filterable clearable placeholder="请选择" style="width: 100%">
                  <el-option v-for="item in citiesOption" :key="item.area_id" :label="item.name" :value="item.area_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="电子邮箱" prop="email">
                <el-input v-model="addCustomerForm.email"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话" prop="telephone">
                <el-input v-model="addCustomerForm.telephone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="手机" prop="fax">
                <el-input v-model="addCustomerForm.fax"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="其他方式" prop="other_contact_way">
                <el-input v-model="addCustomerForm.other_contact_way"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="供应商及价格水平" prop="supplier">
                <el-input type="textarea" v-model="addCustomerForm.supplier" rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="成交情况" prop="price_level">
                <el-input type="textarea" v-model="addCustomerForm.price_level" rows="2"
                  placeholder="时间，品名数量，单价，总金额，付款方式等"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="客户类型" prop="type">
                <el-select v-model="addCustomerForm.type" style="width: 100%">
                  <el-option label="生产" value="生产"></el-option>
                  <el-option label="贸易" value="贸易"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="已成交" prop="completed_transaction">
                <el-switch v-model="addCustomerForm.completed_transaction" active-color="#13ce66"
                  inactive-color="#dedede">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="所属平台" prop="platform">
                <el-select v-model="addCustomerForm.platform" style="width: 100%" filterable>
                  <el-option v-for="item in platformOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="remarks">
                <el-input type="textarea" v-model="addCustomerForm.remarks" rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelAddCustomer">取 消</el-button>
          <el-button type="primary" @click="comfirmAddCustomer">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog :title="editCustomerTitle" :visible.sync="editCustomerVisible" v-loading="editCustomerLoading"
        :close-on-click-modal="false" style="margin-top: -100px;">
        <el-form :model="editCustomerForm" label-width="160px" :rules="addCustomerRules" ref="editCustomerForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="公司名称" prop="company">
                <el-input v-model="editCustomerForm.company"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公司网址" prop="company_site">
                <el-input v-model="editCustomerForm.company_site"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人" prop="contactor">
                <el-input v-model="editCustomerForm.contactor"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="等级" prop="level">
                <el-select v-model="editCustomerForm.level" style="width: 100%">
                  <el-option v-for="item in levelsOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="国家">
                <el-select v-model="editCustomerForm.nation_id" filterable clearable placeholder="请选择"
                  @change="getCities($event, 'add')" style="width: 100%">
                  <el-option v-for="item in countriesOption" :key="item.area_id" :label="item.name"
                    :value="item.area_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地区">
                <el-select v-model="editCustomerForm.area_id" filterable clearable placeholder="请选择"
                  style="width: 100%">
                  <el-option v-for="item in citiesOption" :key="item.area_id" :label="item.name" :value="item.area_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="电子邮箱" prop="email">
                <el-input v-model="editCustomerForm.email"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话" prop="telephone">
                <el-input v-model="editCustomerForm.telephone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="手机" prop="fax">
                <el-input v-model="editCustomerForm.fax"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="其他方式" prop="other_contact_way">
                <el-input v-model="editCustomerForm.other_contact_way"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="供应商及价格水平" prop="supplier">
                <el-input type="textarea" v-model="editCustomerForm.supplier" rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="成交情况" prop="price_level">
                <el-input type="textarea" v-model="editCustomerForm.price_level" rows="2"
                  placeholder="时间，品名数量，单价，总金额，付款方式等"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="客户类型" prop="type">
                <el-select v-model="editCustomerForm.type" style="width: 100%">
                  <el-option label="生产" value="生产"></el-option>
                  <el-option label="贸易" value="贸易"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="已成交" prop="completed_transaction">
                <el-switch v-model="editCustomerForm.completed_transaction" active-color="#13ce66"
                  inactive-color="#dedede">
                </el-switch>
                &nbsp;&nbsp;&nbsp;
                <!-- <el-link :underline="false" v-show="editCustomerForm.completed_transaction == true"
                    @click="showUploadContractDocs()">合同文件</el-link> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="所属平台" prop="platform">
                <el-select v-model="editCustomerForm.platform" style="width: 100%" filterable>
                  <el-option v-for="item in platformOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="remarks">
                <el-input type="textarea" v-model="editCustomerForm.remarks" rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button plain @click="showCustomerTimeline(editCustomerForm.id, editCustomerForm.contactor)"
            icon="el-icon-discover" style="float: left;">时间线</el-button>
          <el-button plain @click="addCustomerTimeline(editCustomerForm.id, editCustomerForm.contactor)"
            icon="el-icon-edit-outline" style="float: left;">添加跟进记录</el-button>
          <el-button plain @click="annotations(editCustomerForm.id, editCustomerForm.contactor)"
            icon="el-icon-notebook-2" style="float: left;">批注</el-button>
          <el-button type="danger" plain @click="notCustomer(editCustomerForm.id)" icon="el-icon-close"
            style="float: left;">这不是客户</el-button>
          <el-button @click="cancelEditCustomer">取 消</el-button>
          <el-button type="primary" @click="comfirmEditCustomer">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog :title="addCustomerTimelineTitle" :visible.sync="addCustomerTimelineVisible">
        <el-form :model="addCustomerTimelineForm" label-width="80px" :rules="addCustomerTimelineRules"
          ref="addCustomerTimelineForm">
          <el-row>
            <el-col :span="20">
              <el-form-item label="跟进日期" prop="follow_at">
                <el-date-picker type="datetime" placeholder="选择日期" v-model="addCustomerTimelineForm.follow_at"
                  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="跟进反馈" prop="feedback">
                <el-input type="textarea" v-model="addCustomerTimelineForm.feedback" rows="5"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="跟进备注">
                <el-input type="textarea" v-model="addCustomerTimelineForm.remarks" rows="4"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="跟进人">
                <el-select v-model="addCustomerTimelineForm.follow_by" filterable placeholder="请选择">
                  <el-option v-for="item in users" :key="item.id" :label="item.name_cn" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelAddCustomerTimeline">取 消</el-button>
          <el-button type="primary" @click="comfirmAddCustomerTimeline">确 定</el-button>
        </div>
      </el-dialog>
      <el-drawer :title="annotationsTitle" :visible.sync="annotationsVisible" direction="rtl">
        <div style="padding: 0 20px;">
          <div v-for="(item, key) in annotationsList" :key="key" class="annotation-block">
            <div class="annotation-box">
              <div class="annotation-box-row">
                <div class="annotation-box-label">内容</div>
                <div class="annotation-box-value">{{ item.content }}
                </div>
              </div>
              <div class="annotation-box-row">
                <div class="annotation-box-label">批注人</div>
                <div class="annotation-box-value">{{ item.creater }}</div>
              </div>
              <div class="annotation-box-row">
                <div class="annotation-box-label">批注时间</div>
                <div class="annotation-box-value">{{ item.created_at }}</div>
              </div>
              <el-divider></el-divider>
            </div>
          </div>
        </div>
        <div style="padding: 15px 20px;" class="demo-drawer__content">
          <el-form :model="annotationsForm" label-width="80px" :rules="annotationsRules" ref="annotationsForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="添加批注" prop="content">
                  <el-input type="textarea" v-model="annotationsForm.content" rows="5"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer" style="float: right;">
            <el-button @click="annotationsVisible = false">关 闭</el-button>
            <el-button type="primary" @click="submitAnnotationsForm">确 定</el-button>
          </div>
        </div>
      </el-drawer>
      <el-drawer :title="timelineDialogTitle" :visible.sync="timelineDialogVisible" direction="ltr">
        <div style="padding: 10px 20px;">
          <div class="radio">
            <el-radio-group v-model="reverse">
              <el-radio :label="true">倒序</el-radio>
              <el-radio :label="false">正序</el-radio>
            </el-radio-group>
          </div>
          <div class="timeline-block" v-loading="timelineDialogLoading">
            <el-timeline :reverse="reverse">
              <el-timeline-item v-for="(timeline, index) in timelines" :key="index" :timestamp="timeline.timestamp">
                <div class="timeline-box">
                  <div class="timeline-box-row">
                    <div class="timeline-box-label">内容</div>
                    <div class="timeline-box-value">{{ timeline.feedback }}</div>
                  </div>
                  <div class="timeline-box-row">
                    <div class="timeline-box-label">备注</div>
                    <div class="timeline-box-value">{{ timeline.remarks }}
                      &nbsp;&nbsp;&nbsp;
                      <el-link v-if="timeline.message_id" title="查看邮件" :underline="false"
                        @click="showEmailContent(timeline.message_id)">点击查看邮件 <i class="el-icon-view"></i>
                      </el-link>
                    </div>
                  </div>
                  <div class="timeline-box-row">
                    <div class="timeline-box-label" :class="timeline.id == null ? 'sender_label' : 'receiver_label'">{{
                      timeline.id == null ? '来信人' : '跟进人' }}</div>
                    <div class="timeline-box-value">{{ timeline.follower }}</div>
                  </div>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </el-drawer>
      <el-dialog :title="emailDetail.subject" :visible.sync="emailDetailVisible">
        <div style="height: 500px;" v-loading="emailDetailLoading" element-loading-text="正在加载">
          <template v-if="emailDetail.text_html != '' && emailDetail.text_html != null">
            <iframe :srcdoc="emailDetail.text_html"></iframe>
          </template>
          <template v-if="emailDetail.text_html == '' || emailDetail.text_html == null">
            <div v-html="emailDetail.text_plain"></div>
          </template>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="emailDetailVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="'跟踪客户 : ' + followCustomersForm.customer_name" :visible.sync="followCustomersVisible">
        <div v-loading="followCustomersLoading">
          <el-form :model="followCustomersForm" label-width="80px" :rules="followCustomersRules"
            ref="followCustomersForm">
            <el-row>
              <el-col :span="12">
                <el-form-item label="跟踪信" prop="follow_letter_id">
                  <el-select v-model="followCustomersForm.follow_letter_id" filterable placeholder="请选择"
                    style="width: 100%;">
                    <el-option v-for="item in follow_letters" :key="item.id" :label="item.title" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="周期(D)" prop="follow_period">
                  <el-input v-model="followCustomersForm.follow_period" placeholder="Day(s)" type="number"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="模式" prop="follow_mode">
                  <el-select v-model="followCustomersForm.follow_mode" filterable placeholder="请选择"
                    @change="toggleFollowEndTime" style="width: 100%;">
                    <el-option v-for="item in follow_mode_options" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-show="followEndTimeVisable">
                <el-form-item label="截止日期">
                  <el-date-picker type="date" placeholder="选择日期" v-model="followCustomersForm.end_time"
                    style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="自动跟踪">
                  <el-switch v-model="followCustomersForm.in_auto_followed" active-color="#13ce66"
                    inactive-color="#dedede">
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="cancelFollowCustomers">取 消</el-button>
          <el-button type="primary" @click="confirmFollowCustomers">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="recycleBinCustomerTitle" :visible.sync="recycleBinCustomerVisible"
        :close-on-click-modal="false">
        <el-form :model="recycleBinCustomer" label-width="160px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="公司名称" prop="company">
                <el-input v-model="recycleBinCustomer.company" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公司网址" prop="company_site">
                <el-input v-model="recycleBinCustomer.company_site" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人" prop="contactor">
                <el-input v-model="recycleBinCustomer.contactor" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="等级" prop="level">
                <el-select v-model="recycleBinCustomer.level" style="width: 100%" readonly>
                  <el-option v-for="item in levelsOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="国家">
                <el-select v-model="recycleBinCustomer.nation_id" filterable clearable placeholder="请选择"
                  @change="getCities($event, 'add')" style="width: 100%;" disabled>
                  <el-option v-for="item in countriesOption" :key="item.area_id" :label="item.name"
                    :value="item.area_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地区">
                <el-select v-model="recycleBinCustomer.area_id" filterable clearable placeholder="请选择"
                  style="width: 100%;" disabled>
                  <el-option v-for="item in citiesOption" :key="item.area_id" :label="item.name" :value="item.area_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="电子邮箱" prop="email">
                <el-input v-model="recycleBinCustomer.email" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话" prop="telephone">
                <el-input v-model="recycleBinCustomer.telephone" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="手机" prop="fax">
                <el-input v-model="recycleBinCustomer.fax" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="其他方式" prop="other_contact_way">
                <el-input v-model="recycleBinCustomer.other_contact_way" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="供应商及价格水平" prop="supplier">
                <el-input type="textarea" v-model="recycleBinCustomer.supplier" rows="2" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="成交情况" prop="price_level">
                <el-input type="textarea" v-model="recycleBinCustomer.price_level" rows="2" readonly
                  placeholder="时间，品名数量，单价，总金额，付款方式等"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="客户类型" prop="type">
                <el-select v-model="recycleBinCustomer.type" style="width: 100%; color:#606266" disabled>
                  <el-option label="生产" value="生产"></el-option>
                  <el-option label="贸易" value="贸易"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="已成交" prop="completed_transaction">
                <el-switch v-model="recycleBinCustomer.completed_transaction" active-color="#13ce66"
                  inactive-color="#dedede" readonly>
                </el-switch>
                &nbsp;&nbsp;&nbsp;
                <!-- <el-link :underline="false" v-show="editCustomerForm.completed_transaction == true"
                    @click="showUploadContractDocs()">合同文件</el-link> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="remarks">
                <el-input type="textarea" v-model="recycleBinCustomer.remarks" rows="2" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button plain @click="showCustomerTimeline(editCustomerForm.id, editCustomerForm.contactor)"
            icon="el-icon-discover" style="float: left;">时间线</el-button>
          <el-button type="primary" @click="recycleBinCustomerVisible = false; recycleBinCustomer = {}">关
            闭</el-button>
        </div>
      </el-dialog>
    </el-tabs>
  </div>
</template>

<script>
import Nav from '../Global/Nav.vue'
import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

var _EditorOption_ = {
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ size: [12, 14, 16] }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ['clean'],
      ['link', 'image', 'video']
    ]
  },
  placeholder: '请输入正文'
};
// toolbar标题
const titleConfig = [
  { Choice: '.ql-insertMetric', title: '跳转配置' },
  { Choice: '.ql-bold', title: '加粗' },
  { Choice: '.ql-italic', title: '斜体' },
  { Choice: '.ql-underline', title: '下划线' },
  { Choice: '.ql-header', title: '段落格式' },
  { Choice: '.ql-strike', title: '删除线' },
  { Choice: '.ql-blockquote', title: '块引用' },
  { Choice: '.ql-code', title: '插入代码' },
  { Choice: '.ql-code-block', title: '插入代码段' },
  { Choice: '.ql-font', title: '字体' },
  { Choice: '.ql-size', title: '字体大小' },
  { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
  { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
  { Choice: '.ql-direction', title: '文本方向' },
  { Choice: '.ql-header[value="1"]', title: 'h1' },
  { Choice: '.ql-header[value="2"]', title: 'h2' },
  { Choice: '.ql-align', title: '对齐方式' },
  { Choice: '.ql-color', title: '字体颜色' },
  { Choice: '.ql-background', title: '背景颜色' },
  { Choice: '.ql-image', title: '图像' },
  { Choice: '.ql-video', title: '视频' },
  { Choice: '.ql-link', title: '添加链接' },
  { Choice: '.ql-formula', title: '插入公式' },
  { Choice: '.ql-clean', title: '清除字体格式' },
  { Choice: '.ql-script[value="sub"]', title: '下标' },
  { Choice: '.ql-script[value="super"]', title: '上标' },
  { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
  { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
  { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
  { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
  { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
  { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
  { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
  { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
  { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
  { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
  { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
  { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
  { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
  { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
  { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '居右对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐' }
];
export default {
  name: 'Customers',
  components: {
    Nav,
    quillEditor
  },
  data() {
    return {
      editorOption: _EditorOption_,
      activeName: 'customers',
      keywords: '',
      vLoading: false,
      customersList: [],
      customersTotal: 0,
      current_page: 1,
      size: 10,
      addCustomerVisible: false,
      addCustomerLoading: false,
      levelsOption: [],
      countriesOption: [],
      citiesOption: [],
      platformOption: [],
      addCustomerForm: {
        company: null,
        company_site: null,
        contactor: null,
        level: null,
        nation_id: null,
        area_id: null,
        email: null,
        telephone: null,
        fax: null,
        other_contact_way: null,
        remarks: null,
        platform: null
      },
      addCustomerRules: {
        contactor: [
          { required: true, message: '联系人不能为空', trigger: 'commit' }
        ],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'commit' }
        ]
      },
      editCustomerTitle: '',
      editCustomerVisible: false,
      editCustomerLoading: false,
      editCustomerForm: {
        company: null,
        company_site: null,
        contactor: null,
        level: null,
        nation_id: null,
        area_id: null,
        email: null,
        telephone: null,
        fax: null,
        other_contact_way: null,
        remarks: null,
        platform: null
      },
      addCustomerTimelineTitle: '',
      addCustomerTimelineVisible: false,
      addCustomerTimelineForm: {
        customer_id: '',
        follow_at: '',
        feedback: '',
        remarks: '',
        follow_by: this.$userinfo.id
      },
      addCustomerTimelineRules: {
        follow_at: [
          { required: true, message: '此项必填', trigger: 'commit' }
        ],
        feedback: [
          { required: true, message: '此项必填', trigger: 'commit' }
        ]
      },
      users: [],
      timelineDialogTitle: '',
      timelineDialogVisible: false,
      timelineDialogLoading: false,
      reverse: true,
      timelines: [],
      emailDetailVisible: false,
      emailDetail: {},
      emailDetailLoading: false,
      followLettersKeywords: '',
      followLettersList: [],
      followLettersTotal: 0,
      followLettersSize: 10,
      followLettersPage: 1,
      addAutoFollowLettersLoading: false,
      addAutoFollowLettersVisible: false,
      addAutoFollowLettersForm: {
        title: '',
        content: ''
      },
      addAutoFollowLettersRules: {
        content: [
          { required: true, message: '正文不能为空', trigger: 'commit' }
        ]
      },
      editAutoFollowLettersLoading: false,
      editAutoFollowLettersVisible: false,
      editAutoFollowLettersForm: {
        title: '',
        content: ''
      },
      editAutoFollowLettersRules: {
        content: [
          { required: true, message: '正文不能为空', trigger: 'commit' }
        ]
      },
      followCustomersVisible: false,
      followCustomersLoading: false,
      followCustomersForm: {
        customer_id: '',
        customer_name: '',
        follow_period: 7,
        follow_mode: '1',
        in_auto_followed: true
      },
      followCustomersRules: {
        follow_letter_id: [
          { required: true, message: '不能为空', trigger: 'commit' }
        ]
      },
      follow_letters: [],
      follow_mode_options: [
        {
          label: '回复为止',
          value: '1'
        },
        {
          label: '指定日期',
          value: '2'
        }
      ],
      followEndTimeVisable: false,
      recycleBinList: [],
      recycleBinTotal: 0,
      recycleBinCurrentPage: 1,
      recycleBinSize: 10,
      recycleBinCustomerTitle: '',
      recycleBinCustomerVisible: false,
      recycleBinCustomer: {},
      queryPlatform: null,
      annotationsList: [],
      annotationsTitle: '',
      annotationsVisible: false,
      annotationsForm: {
        customer_id: '',
        content: ''
      },
      annotationsRules: {
        content: [
          { required: true, message: '内容不能为空', trigger: 'commit' }
        ]
      }
    }
  },
  mounted() {
    this.getPlatforms();
    setTimeout(() => {
      this.current_page = 1;
      this.queryCustomersList();
    }, 0)
    // this.intervals = setInterval(() => {
    //   if (this.activeName == 'worldmap') {
    //     this.worldMap();
    //   }
    // }, 30000);
  },
  methods: {
    tabClick(tab, event) {
      switch (tab.name) {
        case 'customers':
          this.queryCustomersList();
          break;
        case 'follow_letter':
          this.queryFollowLettersList();
          break;
        case 'recycle_bin':
          this.queryRecycleBinList();
          break;
        case 'worldmap':
          this.worldMap();
          break;
      }
    },
    worldMap() {
      this.$axios.get('/customers/master/map').then((response) => {
        var geoCoordMap = response.data.data.geoCoordMap
        var BJData = response.data.data.BJData
        let myChart = this.$echarts.init(document.getElementById("main"));
        var series = [];
        [[, BJData]].forEach(function (item, i) {
          series.push({
            type: 'effectScatter',
            coordinateSystem: "geo",
            zlevel: 2,
            rippleEffect: {
              // 涟漪特效
              period: 4, // 动画时间，值越小速度越快
              brushType: 'stroke', // 波纹绘制方式 stroke, fill
              scale: 10
              // 波纹圆环最大限制，值越大波纹越大
            },
            label: {
              normal: {
                show: true,
                position: 'right', // 显示位置
                offset: [5, 0], // 偏移设置
                formatter: "{b}" // 圆环显示文字
              },
              emphasis: {
                show: true
              }
            },
            symbol: "circle",
            symbolSize: function (val) {
              var level = 0;
              var state = Math.floor(val[2] / 5000);
              level = (state >= 0 && state <= 9) ? state : 10;
              return 5 + level; // 圆环大小
            },
            data: item[1].map(function (dataItem) {
              return {
                name: dataItem.name,
                value: geoCoordMap[dataItem.name]
                  .concat([dataItem.value])
              };
            })
          });
        });

        let option = {
          backgroundColor: '#000',
          // 悬浮提示
          tooltip: {
            trigger: "item",
            backgroundColor: "#FFF",
            borderColor: "#FFFFCC",
            showDelay: 0,
            hideDelay: 0,
            // enterable: true,
            transitionDuration: 0,
            // extraCssText: "z-index:100",formatter
            formatter: function (params, ticket, callback) {
              var res = "";
              var value = params.value[params.seriesIndex + 2];
              res = "Customers: " + value;
              return res;
            }
          },
          visualMap: {
            // 图例值控制
            min: 0,
            max: 10000,
            text: ['High', 'Low'],
            show: false,
            calculable: true,
            color: ["#0BC7FF"]
          },
          geo: {
            map: "world",
            label: {
              emphasis: {
                show: false
              }
            },
            roam: true, // 是否允许缩放
            layoutCenter: ["50%", "50%"], // 地图位置
            layoutSize: "180%",
            itemStyle: {
              normal: {
                color: ["#FFF"], // 地图背景色
                borderColor: "#5bc1c9" // 省市边界线
              },
              emphasis: {
                color: "rgba(37, 43, 61, .5)" // 悬浮背景
              }
            }
          },
          series: series
        };
        myChart.setOption(option);
      })
    },
    async getPlatforms() {
      await this.$axios.get('/customers/master/platforms').then((response) => {
        this.platformOption = response.data.data;
      });
    },
    queryCustomersList() {
      this.vLoading = true;
      let current_page = this.current_page;
      let keywords = this.keywords;
      let size = this.size;
      let platform = this.queryPlatform;
      this.$axios.get('/customers/master/list', {
        params: {
          keywords: keywords,
          page: current_page,
          size: size,
          platform: platform
        }
      }).then((response) => {
        this.vLoading = false
        if (response.data.code === 200) {
          this.customersList = response.data.data.data;
          this.customersTotal = response.data.data.total;
        }
      })
    },
    changeCustomersSize(val) {
      this.size = val;
      this.queryCustomersList();
    },
    currentCustomersChange(val) {
      this.current_page = val;
      this.queryCustomersList();
    },
    async addCustomer() {
      this.addCustomerVisible = true;
      this.addCustomerLoading = true;
      await this.$axios.get('/customers/master/options').then((response) => {
        this.levelsOption = response.data.data.levels;
        this.countriesOption = response.data.data.world_cities;
      });
      this.addCustomerLoading = false;
    },
    cancelAddCustomer() {
      this.addCustomerVisible = false;
      this.addCustomerForm = {
        company: '',
        company_site: '',
        contactor: '',
        level: '',
        nation_id: '',
        area_id: '',
        email: '',
        telephone: '',
        fax: '',
        other_contact_way: '',
        remarks: ''
      }
    },
    async comfirmAddCustomer() {
      this.$refs.addCustomerForm.validate(valid => {
        if (valid) {
          this.addCustomerLoading = true;
          this.$axios.post('/customers/master/add',
            this.addCustomerForm
          ).then((response) => {
            this.queryCustomersList();
            this.addCustomerVisible = false;
            this.addCustomerLoading = false;
          }).catch(function (error) {
            this.addCustomerLoading = false;
          })
          this.addCustomerForm = {
            company: '',
            company_site: '',
            contactor: '',
            level: '',
            nation_id: '',
            area_id: '',
            email: '',
            telephone: '',
            fax: '',
            other_contact_way: '',
            remarks: ''
          }
        }
      })
    },
    async getCities(v, type) {
      if (type === 'add') {
        this.addCustomerLoading = true;
      } else if (type === 'edit') {
        this.editCustomerLoading = true;
      }
      this.addCustomerForm.area_id = '';
      this.citiesOption = [];
      await this.$axios.get('/basic/world_city_list', {
        params: {
          parent_id: v
        }
      }).then((response) => {
        if (response.data.code === 200) {
          this.citiesOption = response.data.data;
          this.addCustomerLoading = false;
          this.editCustomerLoading = false;
        }
      });
    },
    async editCustomers(row) {
      this.editCustomerVisible = true;
      this.editCustomerLoading = true;
      await this.$axios.get('/customers/master/options').then((response) => {
        if (response.data.code === 200) {
          this.levelsOption = response.data.data.levels;
          this.countriesOption = response.data.data.world_cities;
        }
      });
      let id = row.id;
      await this.$axios.get(`/customers/master/detail`, {
        params: {
          id: id
        }
      }).then((response) => {
        if (response.data.code === 200) {
          this.editCustomerForm = response.data.data;
          this.editCustomerTitle = response.data.data.contactor
          setTimeout(() => {
            this.getCities(response.data.data.nation_id)
          })
        }
      });
      this.editCustomerLoading = false;
    },
    cancelEditCustomer() {
      this.editCustomerVisible = false;
      this.editCustomerForm = {
        company: '',
        company_site: '',
        contactor: '',
        level: '',
        nation_id: '',
        area_id: '',
        email: '',
        telephone: '',
        fax: '',
        other_contact_way: '',
        remarks: ''
      }
    },
    async comfirmEditCustomer() {
      this.$refs.editCustomerForm.validate(valid => {
        if (valid) {
          this.editCustomerLoading = true;
          this.$axios.post('/customers/master/edit',
            this.editCustomerForm
          ).then((response) => {
            this.queryCustomersList();
            this.editCustomerVisible = false;
            this.editCustomerLoading = false;
          }).catch(function (error) {
            this.editCustomerLoading = false;
          })
          this.editCustomerForm = {
            company: '',
            company_site: '',
            contactor: '',
            level: '',
            nation_id: '',
            area_id: '',
            email: '',
            telephone: '',
            fax: '',
            other_contact_way: '',
            remarks: ''
          }
        }
      })
    },
    async addCustomerTimeline(customer_id, contactor) {
      this.addCustomerTimelineVisible = true;
      this.addCustomerTimelineTitle = "添加" + contactor + "的跟进记录";
      this.addCustomerTimelineForm.customer_id = customer_id
      await this.$axios.get(`/basic/users/list`).then((response) => {
        if (response.data.code === 200) {
          this.users = response.data.data
        }
      })
    },
    cancelAddCustomerTimeline() {
      this.addCustomerTimelineVisible = false;
      this.addCustomerTimelineForm = {
        customer_id: '',
        follow_at: '',
        feedback: '',
        remarks: '',
        follow_by: this.$userinfo.id
      }
    },
    comfirmAddCustomerTimeline() {
      this.$refs.addCustomerTimelineForm.validate(valid => {
        if (valid) {
          this.$axios.post('/customers/master/record',
            this.addCustomerTimelineForm
          ).then((response) => {
            this.$notify({
              title: 'success',
              message: '添加成功',
              type: 'success'
            })
            this.queryCustomersList();
            this.addCustomerTimelineVisible = false;
          }).catch(function (error) {

          })
          this.addCustomerTimelineForm = {
            customer_id: '',
            follow_at: '',
            feedback: '',
            remarks: '',
            follow_by: this.$userinfo.id
          };
        }
      })
    },
    async showCustomerTimeline(customer_id, contactor) {
      this.timelineDialogVisible = true;
      this.timelineDialogTitle = contactor + "的联系记录";
      this.timelineDialogLoading = true;
      await this.$axios.get(`/customers/master/timeline?customer_id=` + customer_id).then((response) => {
        this.timelineDialogLoading = false;
        if (response.data.code === 200) {
          this.timelines = response.data.data
        }
      })
    },
    async showEmailContent(message_id) {
      this.emailDetail = {};
      this.emailDetailLoading = true;
      this.emailDetailVisible = true;
      await this.$axios.get(`mailer/email/detail?message_id=` + message_id + `&seen=1`)
        .then((response) => {
          if (response.data.code === 200) {
            this.emailDetail = response.data.data
          } else {
            this.$notify({
              title: 'Error',
              message: response.data.data,
              type: 'error'
            })
          }
          this.emailDetailLoading = false;
        });
    },
    showUploadContractDocs() { },
    addFollowLetter() {
      this.addAutoFollowLettersVisible = true
    },
    cancelAddAutoFollowLetters() {
      this.addAutoFollowLettersVisible = false;
      this.addAutoFollowLettersForm = {
        title: '',
        content: ''
      }
    },
    async comfirmAddAutoFollowLetters() {
      this.$refs.addAutoFollowLettersForm.validate(valid => {
        if (valid) {
          this.addAutoFollowLettersLoading = true;
          this.$axios.post('/customers/follow_letters/add',
            this.addAutoFollowLettersForm
          ).then(() => {
            this.queryFollowLettersList();
            this.addAutoFollowLettersVisible = false;
            this.addAutoFollowLettersLoading = false;
          }).catch(function () {
            this.addAutoFollowLettersLoading = false;
          })
          this.addAutoFollowLettersForm = {
            title: '',
            content: ''
          }
        }
      })
    },
    editFollowLetter(row) {
      this.editAutoFollowLettersVisible = true;
      this.editAutoFollowLettersLoading = true;
      this.$axios.get(`/customers/follow_letters/detail?id=${row.id}`).then((response) => {
        this.editAutoFollowLettersLoading = false;
        if (response.data.code === 200) {
          this.editAutoFollowLettersForm = response.data.data;
        } else {
          this.$notify({
            title: 'failed',
            message: response.data.data,
            type: 'warning'
          })
        }
      })
    },
    cancelEditAutoFollowLetters() {
      this.editAutoFollowLettersVisible = false;
      this.editAutoFollowLettersForm = {
        title: '',
        content: ''
      }
    },
    async comfirmEditAutoFollowLetters() {
      this.$refs.editAutoFollowLettersForm.validate(valid => {
        if (valid) {
          this.editAutoFollowLettersLoading = true;
          this.$axios.post('/customers/follow_letters/save',
            this.editAutoFollowLettersForm
          ).then((response) => {
            this.editAutoFollowLettersLoading = false;
            if (response.data.code === 200) {
              if (response.data.data.code === 1) {
                this.queryFollowLettersList();
                this.editAutoFollowLettersVisible = false;
              } else if (response.data.data.code === 2) {
                this.$confirm("此信正在用于客户\n[ " + response.data.data.data + " ]\n的自动跟踪, 确定保存吗", '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.$axios.post('/customers/follow_letters/real_save',
                    this.editAutoFollowLettersForm
                  ).then((response) => {
                    if (response.data.code === 200) {
                      this.queryFollowLettersList();
                      this.editAutoFollowLettersVisible = false;
                    }
                  })
                })
              }
            }
          }).catch(function () {
            this.editAutoFollowLettersLoading = false;
          })
          // this.editAutoFollowLettersForm = {
          //   title: '',
          //   content: ''
          // }
        }
      })
    },
    queryFollowLettersList() {
      this.vLoading = true;
      let current_page = this.followLettersPage;
      let keywords = this.followLettersKeywords;
      let size = this.followLettersSize;
      this.$axios.get('/customers/follow_letters/list', {
        params: {
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.vLoading = false
        if (response.data.code === 200) {
          this.followLettersList = response.data.data.data;
          this.followLettersTotal = response.data.data.total;
        }
      })
    },
    changeFollowLettersSize(val) {
      this.followLettersSize = val;
      this.queryFollowLettersList();
    },
    currentFollowLettersChange(val) {
      this.followLettersPage = val;
      this.queryFollowLettersList();
    },
    followCustomers(row) {
      this.followCustomersVisible = true;
      this.followCustomersLoading = true;
      this.followCustomersForm = {
        customer_id: row.id,
        customer_name: row.contactor,
        follow_period: row.follow_period || 7,
        follow_mode: row.follow_mode || '1',
        end_time: row.follow_end_date,
        follow_letter_id: row.follow_letter_id,
        in_auto_followed: row.in_auto_followed
      }
      if (row.follow_mode === "2") {
        this.followEndTimeVisable = true;
      } else {
        this.followEndTimeVisable = false;
      }
      this.$axios.get(`/customers/follow_letters/options`).then((response) => {
        this.followCustomersLoading = false;
        if (response.data.code === 200) {
          this.follow_letters = response.data.data;
        }
      })
    },
    toggleFollowEndTime() {
      if (this.followCustomersForm.follow_mode === '2') {
        this.followEndTimeVisable = true
      } else {
        this.followEndTimeVisable = false
      }
    },
    cancelFollowCustomers() {
      this.followCustomersVisible = false;
      this.followCustomersLoading = false;
      this.followEndTimeVisable = false;
      this.followCustomersForm = {
        customer_id: '',
        customer_name: '',
        follow_period: 7,
        follow_mode: '1',
        in_auto_followed: true,
        end_time: null,
        follow_letter_id: ''
      }
    },
    confirmFollowCustomers() {
      this.$refs.followCustomersForm.validate(valid => {
        if (valid) {
          this.followCustomersLoading = true;
          this.$axios.post(`/customers/master/follow`,
            this.followCustomersForm
          ).then((response) => {
            this.followCustomersLoading = false;
            if (response.data.code === 200) {
              this.followCustomersVisible = false;
              this.queryCustomersList();
            }
          })
        }
      })
    },
    deleteFollowLetter(row) {
      this.$confirm("确定删除吗", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/customers/follow_letters/delete',
          {
            id: row.id
          }
        ).then((response) => {
          if (response.data.code === 200) {
            this.queryFollowLettersList();
          }
        })
      })
    },
    notCustomer(id) {
      this.$confirm("确定移除吗", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/customers/master/delete',
          {
            id: id
          }
        ).then((response) => {
          if (response.data.code === 200) {
            this.editCustomerVisible = false;
            this.queryCustomersList();
          }
        })
      })
    },
    changeRecycleBinSize(val) {
      this.recycleBinSize = val;
      this.queryRecycleBinList();
    },
    currentRecycleBinChange(val) {
      this.recycleBinCurrentPage = val;
      this.queryRecycleBinList();
    },
    queryRecycleBinList() {
      this.vLoading = true;
      let current_page = this.recycleBinCurrentPage;
      let size = this.recycleBinSize;
      this.$axios.get('/customers/master/recycle_bin', {
        params: {
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.vLoading = false
        if (response.data.code === 200) {
          this.recycleBinList = response.data.data.data;
          this.recycleBinTotal = response.data.data.total;
        }
      })
    },
    async viewRecycleBinCustomers(row) {
      this.recycleBinCustomer = {};
      this.recycleBinCustomerVisible = true;
      await this.$axios.get('/customers/master/options').then((response) => {
        if (response.data.code === 200) {
          this.levelsOption = response.data.data.levels;
          this.countriesOption = response.data.data.world_cities;
        }
      });
      let id = row.id;
      await this.$axios.get(`/customers/master/detail`, {
        params: {
          id: id
        }
      }).then((response) => {
        if (response.data.code === 200) {
          this.recycleBinCustomer = response.data.data;
          this.recycleBinCustomerTitle = response.data.data.contactor
          setTimeout(() => {
            this.getCities(response.data.data.nation_id)
          })
        }
      });
    },
    restoreRecycleBinCustomers(row) {
      this.$confirm("确定还原吗", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/customers/master/restore',
          {
            id: row.id
          }
        ).then((response) => {
          if (response.data.code === 200) {
            this.queryRecycleBinList();
          }
        })
      })
    },
    annotations(id, contactor) {
      this.annotationsTitle = contactor + '的批注';
      this.annotationsForm = {
        customer_id: id,
        content: ''
      }
      this.$axios.get(`/customers/master/annotaions?customer_id=${id}`).then((response) => {
        this.annotationsList = response.data.data
      });
      this.annotationsVisible = true;
    },
    cancelAnnotationsForm() {
      this.annotationsVisible = false;
    },
    submitAnnotationsForm() {
      this.$refs.annotationsForm.validate(valid => {
        if (valid) {
          this.$axios.post(`/customers/master/annotation_add`,
            this.annotationsForm
          ).then(() => {
            this.annotationsVisible = false;
          })
        }
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.intervals);
  }
}
</script>

<style scoped>
iframe {
  width: 100%;
  height: 99%;
  overflow: auto;
  border: none;
}

.el-tabs {
  height: 100%;
}

.main {
  width: 100%;
  height: calc(100vh - 200px);
}

a {
  color: inherit;
}

a:hover {
  color: #409EFF;
}

.timeline-block {
  margin-top: 20px;
  overflow: auto;
  padding: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

.timeline-block /deep/ .el-timeline-item__timestamp {
  border-bottom: solid 1px #E4E7ED;
  padding-bottom: 5px;
}

.timeline-box-row {
  width: 100%;
  display: flex;
  align-items: start;
  margin-bottom: 8px;

  .timeline-box-label {
    width: 60px;
    color: gray;
    min-height: 24px;
    line-height: 24px;
  }

  .timeline-box-label::after {
    content: ':';
  }

  .timeline-box-value {
    width: calc(100% - 60px);
    min-height: 24px;
    line-height: 24px;
  }
}

.annotation-box-row {
  width: 100%;
  display: flex;

  .annotation-box-label {
    width: 80px;
    min-height: 32px;
    line-height: 32px;
    color: gray;
  }

  .annotation-box-label::after {
    content: ':';
  }

  .annotation-box-value {
    width: calc(100% - 80px);
    min-height: 32px;
    line-height: 32px;
  }
}

.sender_label {
  color: red !important;
}

.receiver_label {
  color: #409EFF !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Modules/Customers.vue